import { DispatchReset, PagedReducer, PagedReducerReset } from "base/src/utils/reducerUtil";
import { CARTEIRA_PERMISSAO_GET, CARTEIRA_PERMISSAO_UPDATE, CARTEIRA_USUARIO_GET, CarteiraAdminActionTypes, CarteiraAdminState } from "../../../types/carteiraAdmin/carteiraAdmin";
import { CarteiraUsuarioResponse } from "domain/types/_carteira/carteiraBase/carteiraUsuarioResponse";
import { UsuarioCarteiraResponse } from "../../../types/carteiraAdmin/carteiraUsuarioResponse";
import { IPagedListResponse } from "domain/types/global/pagedListResponse";

const INITIAL_STATE: CarteiraAdminState = {
    CarteiraUsuarios: undefined,
    CarteiraPermissao: undefined,
}

export function CarteiraAdminReducer(state = INITIAL_STATE, action: CarteiraAdminActionTypes): CarteiraAdminState {
    switch (action.type) {
        case CARTEIRA_PERMISSAO_GET:
            return { ...state, CarteiraPermissao: action.payload }

        case CARTEIRA_USUARIO_GET:
            //return {...state, UsuariosEmpresa:action.payload}
            return PagedReducer(state, "CarteiraUsuarios", action.payload, "UsuarioID", CARTEIRA_USUARIO_GET )
                        
        case DispatchReset(CARTEIRA_USUARIO_GET):
            return PagedReducerReset(state, "CarteiraUsuarios", {} as IPagedListResponse<CarteiraUsuarioResponse>, "CampanhaPedidoResgateID", CARTEIRA_USUARIO_GET)

        case CARTEIRA_PERMISSAO_UPDATE:
            if (state.CarteiraUsuarios && state.CarteiraUsuarios.Result) {
                const updatedResult = state.CarteiraUsuarios.Result.map((usuario: UsuarioCarteiraResponse) => {
                    if (usuario.UsuarioID === action.payload.UsuarioID) {
                        return {
                            ...usuario,
                            PossuiPermissao: action.payload.Status,
                            CarteiraPermissaoTipoID: action.payload.Status ? action.payload.CarteiraPermissaoTipoID : undefined
                        };
                    }
                    return usuario;
                });
                
                return {
                    ...state,
                    CarteiraUsuarios: {
                        ...state.CarteiraUsuarios,
                        Result: updatedResult
                    }
                };
            }
            return state; 

        default:
            return state
    }
}